import React from 'react';
// utilities
import { messageUtility } from '../../utilities/messageUtility';

// components
import { Information } from '../modals/common';

export default function LwTalkroomCantSettingsModal({ visible, setVisible }) {
  return (
    <Information
      title={messageUtility.getMessage('I-001-524')}
      rootClassName='dialog-error-lw-talkroom'
      message={messageUtility.getMessage('I-001-525')}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={() => {
        setVisible(false);
      }}
      visible={visible}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/LwTalkroomCantSettingsModal.jsx